/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  if (window.__elppisMoqQuantity) {
    return;
  }

  window.__elppisMoqQuantity = true;

  var minimumQuantity = 6;
  var quantityStep = 6;

  function toNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getMinimum(input) {
    return toNumber(input.getAttribute('data-min') || input.getAttribute('min'), minimumQuantity);
  }

  function getStep(input) {
    return toNumber(input.getAttribute('step') || input.getAttribute('data-quantity-step'), quantityStep);
  }

  function getMaximum(input) {
    return toNumber(input.getAttribute('data-max') || input.getAttribute('max') || input.getAttribute('data-quantity-max'), 0);
  }

  function isQuantityInput(input) {
    return Boolean(input) && (
      input.matches('[data-quantity-field]') ||
      input.name === 'quantity' ||
      input.name === 'updates[]'
    );
  }

  function normalizeQuantity(value, input) {
    var min = getMinimum(input);
    var step = getStep(input);
    var quantity = toNumber(value, min);

    if (quantity < min) {
      quantity = min;
    }

    var remainder = quantity % step;
    if (remainder !== 0) {
      quantity += step - remainder;
    }

    var max = getMaximum(input);
    if (max > 0 && quantity > max) {
      quantity = Math.floor(max / step) * step;
      if (quantity < min) {
        quantity = min;
      }
    }

    return quantity;
  }

  function syncQuantityText(input) {
    var roots = [
      input.closest('[data-quantity-wrapper]'),
      input.closest('[data-quantity-holder]'),
      input.closest('[data-cart-bar-qty]'),
      input.closest('.cart__item__bottom')
    ].filter(Boolean);

    roots.forEach(function(root) {
      root.querySelectorAll('[data-quantity-select]').forEach(function(text) {
        if (text.textContent !== input.value) text.textContent = input.value;
      });
    });
  }

  function prepareQuantityInput(input) {
    if (!isQuantityInput(input)) {
      return;
    }

    syncProductQuantityMode(input);
    var min = getMinimum(input);
    var step = getStep(input);
    input.setAttribute('data-min', String(min));
    input.setAttribute('data-quantity-step', String(step));
    input.setAttribute('min', String(min));
    input.setAttribute('step', String(step));

    var nextValue = normalizeQuantity(input.value, input);
    if (String(nextValue) !== input.value) {
      input.value = nextValue;
    }

    syncQuantityText(input);
    syncQuantityCounterState(input);
  }

  function prepareAllQuantityInputs(root) {
    (root || document).querySelectorAll('[data-quantity-field]').forEach(prepareQuantityInput);
  }

  function syncQuantityCounterState(input) {
    var counter = input.closest('quantity-counter');
    if (!counter) return;
    var maximum = getMaximum(input);
    counter.minValue = getMinimum(input);
    counter.maxValue = maximum > 0 ? maximum : null;
    counter.quantityValue = toNumber(input.value, counter.minValue);
    if (typeof counter.disableIncrease === 'function') counter.disableIncrease();
  }

  function dispatchQuantityChange(input) {
    // The theme counter caches min/max at connection time; update it before
    // its input listener can clamp a MIX pack back to the old six-piece minimum.
    syncQuantityCounterState(input);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getMoneyFormat() {
    if (!window.theme) {
      return '';
    }

    return window.theme.settings && window.theme.settings.currency_code_enable ?
      window.theme.moneyWithCurrencyFormat :
      window.theme.moneyFormat;
  }

  function formatMoney(cents) {
    if (!window.theme || typeof window.theme.formatMoney !== 'function') {
      return '';
    }

    return window.theme.formatMoney(cents, getMoneyFormat());
  }

  function getVariantFromProductInfo(productInfo) {
    var variantScript = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (variantScript && variantScript.textContent.trim()) {
      try {
        return JSON.parse(variantScript.textContent);
      } catch (error) {
        return null;
      }
    }

    return null;
  }

  function getVariantFromForm(productInfo) {
    var formWrapper = productInfo.querySelector('[data-form-wrapper]');
    if (!formWrapper || !formWrapper.dataset.variantPrice) {
      return null;
    }

    return {
      price: toNumber(formWrapper.dataset.variantPrice, 0),
      compare_at_price: toNumber(formWrapper.dataset.variantComparePrice, 0)
    };
  }

  function getCurrentVariant(productInfo) {
    return getVariantFromProductInfo(productInfo) || getVariantFromForm(productInfo);
  }

  function syncProductQuantityMode(input, selectedVariant) {
    if (!input || input.name !== 'quantity') return;
    var productInfo = input.closest('product-info');
    if (!productInfo) return;
    var variant = selectedVariant || getCurrentVariant(productInfo);
    if (!variant || !variant.title) return;
    var mode = variant.title === 'MIX' ? 'pack' : 'pieces';
    var minimum = mode === 'pack' ? 1 : 6;
    var previousMode = input.getAttribute('data-elppis-quantity-mode');
    var reset = previousMode ? previousMode !== mode : getMinimum(input) !== minimum;
    input.setAttribute('data-elppis-quantity-mode', mode);
    input.setAttribute('data-min', String(minimum));
    input.setAttribute('min', String(minimum));
    input.setAttribute('data-quantity-step', String(minimum));
    input.setAttribute('step', String(minimum));
    if (reset) input.value = String(minimum);
    syncQuantityText(input);
  }

  function getProductQuantity(productInfo, sourceInput) {
    var input = sourceInput && productInfo.contains(sourceInput) && sourceInput.name === 'quantity' ?
      sourceInput :
      productInfo.querySelector('[data-form-wrapper] input[name="quantity"][data-quantity-field], input[name="quantity"][data-quantity-field]');

    if (input) {
      syncProductQuantityMode(input);
      prepareQuantityInput(input);
      return normalizeQuantity(input.value, input);
    }
    return minimumQuantity;
  }

  function updatePriceWrapper(wrapper, totalPrice, totalComparePrice, isOnSale) {
    var price = wrapper.querySelector('[data-product-price]');
    if (!price) {
      return;
    }

    var formattedPrice = totalPrice === 0 && window.theme && window.theme.strings ?
      window.theme.strings.free :
      formatMoney(totalPrice);

    if (formattedPrice) {
      if (price.innerHTML !== formattedPrice) price.innerHTML = formattedPrice;
    }

    price.classList.toggle('product__price--sale', Boolean(isOnSale));

    var comparePrice = wrapper.querySelector('[data-compare-price], .product__price--strike');
    if (!comparePrice) {
      return;
    }

    if (isOnSale && totalComparePrice > totalPrice) {
      var formattedComparePrice = formatMoney(totalComparePrice);
      if (formattedComparePrice) {
        if (comparePrice.innerHTML !== formattedComparePrice) comparePrice.innerHTML = formattedComparePrice;
      }
      comparePrice.classList.remove('hidden');
      comparePrice.style.display = '';
    } else {
      comparePrice.classList.add('hidden');
      comparePrice.style.display = 'none';
    }
  }

  function updateWholesalePriceSummary(productInfo, unitPrice, quantity) {
    var variant = getCurrentVariant(productInfo);
    var isMix = Boolean(variant && variant.title === 'MIX');
    var shownUnitPrice = isMix ? unitPrice / 6 : unitPrice;
    productInfo.querySelectorAll('[data-quantity-wrapper] .select__label, [data-cart-bar-qty] input').forEach(function(element) {
      if (element.tagName === 'INPUT') element.setAttribute('aria-label', isMix ? 'Number of packs' : 'Quantity (pieces)');
      else element.textContent = isMix ? 'Number of packs' : 'Quantity (pieces)';
    });
    productInfo.querySelectorAll('[data-elppis-size-order-note]').forEach(function(element) {
      element.textContent = isMix ? '1 pack = 6 pieces · S × 2 / M × 2 / L × 2' : 'Minimum 6 pieces · Order in multiples of 6';
    });
    var formattedUnitPrice = unitPrice === 0 && window.theme && window.theme.strings ?
      window.theme.strings.free :
      formatMoney(shownUnitPrice);

    if (formattedUnitPrice) {
      productInfo.querySelectorAll('[data-wholesale-unit-price]').forEach(function(element) {
        if (element.innerHTML !== formattedUnitPrice) element.innerHTML = formattedUnitPrice;
      });
    }

    productInfo.querySelectorAll('[data-wholesale-total-label]').forEach(function(label) {
      label.textContent = isMix ? quantity + (quantity === 1 ? ' pack' : ' packs') + ' (' + quantity * 6 + ' pcs)' : quantity + ' pcs total';
    });
  }

  function updateProductPriceTotals(productInfo, sourceInput) {
    if (!productInfo) {
      return;
    }

    var variant = getCurrentVariant(productInfo);
    if (!variant || variant.price == null) {
      return;
    }

    var quantity = getProductQuantity(productInfo, sourceInput);
    var unitPrice = toNumber(variant.price, 0);
    var unitComparePrice = toNumber(variant.compare_at_price, 0);
    var totalPrice = unitPrice * quantity;
    var totalComparePrice = unitComparePrice * quantity;
    var isOnSale = unitComparePrice > unitPrice;

    updateWholesalePriceSummary(productInfo, unitPrice, quantity);

    productInfo.querySelectorAll('[data-price-wrapper], .cart-bar__product__price').forEach(function(wrapper) {
      updatePriceWrapper(wrapper, totalPrice, totalComparePrice, isOnSale);
    });
  }

  function updateAllProductPriceTotals(root) {
    (root || document).querySelectorAll('product-info').forEach(function(productInfo) {
      updateProductPriceTotals(productInfo);
    });
  }

  function queueProductPriceUpdate(target) {
    var productInfo = target && target.closest ? target.closest('product-info') : null;
    window.requestAnimationFrame(function() {
      if (productInfo) {
        updateProductPriceTotals(productInfo, target);
      } else {
        updateAllProductPriceTotals(document);
      }
    });
  }

  document.addEventListener('click', function(event) {
    var plusButton = event.target.closest('[data-quantity-plus]');
    var minusButton = event.target.closest('[data-quantity-minus]');

    if (!plusButton && !minusButton) {
      return;
    }

    var holder = event.target.closest('[data-quantity-holder]');
    var input = holder && holder.querySelector('[data-quantity-field]');

    if (!input) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    prepareQuantityInput(input);

    var min = getMinimum(input);
    var step = getStep(input);
    var max = getMaximum(input);
    var quantity = normalizeQuantity(input.value, input);
    var nextQuantity = plusButton ? quantity + step : quantity - step;

    if (nextQuantity < min) {
      nextQuantity = min;
    }

    if (max > 0 && nextQuantity > max) {
      nextQuantity = normalizeQuantity(max, input);
    }

    input.value = nextQuantity;
    syncQuantityText(input);
    dispatchQuantityChange(input);
    queueProductPriceUpdate(input);
  }, true);

  document.addEventListener('input', function(event) {
    if (!isQuantityInput(event.target)) return;
    syncProductQuantityMode(event.target);
    syncQuantityCounterState(event.target);
  }, true);

  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-quantity-field]')) {
      return;
    }

    var input = event.target;
    syncProductQuantityMode(input);
    var nextValue = normalizeQuantity(input.value, input);
    if (String(nextValue) !== input.value) {
      input.value = nextValue;
      syncQuantityText(input);
      dispatchQuantityChange(input);
    }

    queueProductPriceUpdate(input);
  });

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"], form[action*="/cart"]')) {
      return;
    }

    form.querySelectorAll('[data-quantity-field], input[name="quantity"], input[name="updates[]"]').forEach(function(input) {
      prepareQuantityInput(input);
    });
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    prepareAllQuantityInputs(document);
    updateAllProductPriceTotals(document);
  });

  window.addEventListener('pageshow', function() {
    prepareAllQuantityInputs(document);
    updateAllProductPriceTotals(document);
  });

  document.addEventListener('theme:product-info:loaded', function(event) {
    prepareAllQuantityInputs(event.target);
    queueProductPriceUpdate(event.target);
  });

  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS && window.theme.PUB_SUB_EVENTS.variantChange) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function() {
      window.requestAnimationFrame(function() {
        prepareAllQuantityInputs(document);
        updateAllProductPriceTotals(document);
      });
    });
  }

  if (window.MutationObserver) {
    var pendingRoots = new Set();
    var updateScheduled = false;
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          var selector = 'product-info, [data-quantity-field]';
          if (node.matches(selector) || node.querySelector(selector)) pendingRoots.add(node);
        });
      });
      if (pendingRoots.size && !updateScheduled) {
        updateScheduled = true;
        window.requestAnimationFrame(function() {
          updateScheduled = false;
          pendingRoots.forEach(function(root) {
            if (root.matches('[data-quantity-field]')) prepareQuantityInput(root);
            prepareAllQuantityInputs(root);
            if (root.matches('product-info')) updateProductPriceTotals(root);
            updateAllProductPriceTotals(root);
          });
          pendingRoots.clear();
        });
      }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
